import { Col, Logo, UiCenter, UiImage, UiPrimaryButton, UiText } from "~/components/elements";
import checkMark from "~/assets/img/v2/check_mark.png";
import { useHistory } from "react-router-dom";
import React from "react";
import { PAGE_URLS } from "~/constants";

export function Success({ email }: { email: string }) {
  const history = useHistory();

  return (
    <Col mt={8} px={{ base: 4 }} maxW="29.625rem" w="full">
      <Logo containerProps={{ justifyContent: "center" }} />
      <UiCenter flexDirection="column" flex={1} px={3} mt={12}>
        <UiImage src={checkMark} width="5rem" />
        <UiText vr="headline3" fontSize={{ base: "1.5rem", md: "1.75rem" }} mt={4} textAlign="center">
          Password reset successfully!
        </UiText>
        <UiText vr="body1" textAlign="center" mt={4}>
          You can now use your new password to log in to your account.
        </UiText>

        <Col w="full" mt={8}>
          <UiPrimaryButton
            onClick={() => {
              history.push(PAGE_URLS.LOGIN);
            }}
          >
            Sign in
          </UiPrimaryButton>
        </Col>
      </UiCenter>
    </Col>
  );
}
